export default __webpack_public_path__ + "static/media/getReport.06a1560d.svg";